import React from 'react'
import Main from '../Components/Main';
import Navbar from '../Components/Navbar';


function Home() {
  return (
    <>
    <Navbar />
    <Main />
    </>

  )
}

export default Home;